import * as React from 'react';
import { ExcelTool } from '../../excel/excel_tool';
import { WorkBook } from 'xlsx/types';
import style from '../import_tool.less';

interface WImportStepFileCheckProps extends React.ClassAttributes<any> {
    data: any;
    onDataChange: (data: any) => void;
    onDone: () => void;
}

export class ImportStepFileCheckState {
    checkDone: boolean;
    isExcel: boolean;
    workbook?: WorkBook;
    selectedSheet?: string;
    sheetSizes: Array<number>;
}

export class ImportStepFileCheck extends React.Component<WImportStepFileCheckProps, ImportStepFileCheckState> {

    constructor(props: any) {
        super(props);
        this.onSheetSelect = this.onSheetSelect.bind(this);
        this.onButtonPress = this.onButtonPress.bind(this);
        this.state = {
            checkDone: this.props.data.workbook ? true : false,
            isExcel: this.props.data.workbook ? true : false,
            workbook: this.props.data.workbook ? this.props.data.workbook : undefined,
            selectedSheet: this.props.data.sheetName ? this.props.data.sheetName : undefined,
            sheetSizes: this.props.data.sheetSizes ? this.props.data.sheetSizes : []
        };
    }

    private excel_tool = new ExcelTool();

    componentDidMount() {
        if (this.props.data.raw && !this.props.data.workbook) {
            this.check();
        } else if (this.props.data.sheetDataAll) {
            // Hier sollten wir im Bearbeiten-Modus reinkommen
            const checkDone = true;
            const isExcel = true;
            const selectedSheet = this.props.data.sheetName;
            const sheetSizes = this.props.data.sheetSizes || [];
            this.setState({ isExcel, checkDone, selectedSheet, sheetSizes });
        }
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (
            this.state.isExcel && this.state.checkDone && (((prevState.workbook !== this.state.workbook)
            && Object.keys(this.state.workbook || {}).length))
        ) {
            this.checkSheetSize()
        }
    }

    check() {
        // console.log(this.props.data);
        const excel = new ExcelTool();
        const workbook = excel.getWorkbook(this.props.data.raw);
        // console.log(this.props.data.raw);
        if (workbook && workbook.Sheets && workbook.SheetNames.length > 0) {
            const checkDone = true;
            const isExcel = true;
            const selectedSheet = workbook.SheetNames[0];
            this.setState({ isExcel, checkDone, workbook, selectedSheet });
        } else {
            const checkDone = true;
            this.setState({ checkDone });
        }
    }

    checkSheetSize() {
        const sheetNames: Array<string> = this.state.workbook.SheetNames || [];
        const sheetSizes: Array<number> = [];
        let isSingle: boolean = null;
        let rows: number = 0;
        let selectedSheet: string = this.state.selectedSheet;
        (Object.values(this.excel_tool.getJSONAll(this.state.workbook)) || []).forEach((sheet: any, index: number) => {
            const size: number = sheet.length;
            if (isSingle === null && size) {
                isSingle = true;
                selectedSheet = sheetNames[index] || null;
            }
            if (isSingle && rows && size) {
                isSingle = false;
            }
            sheetSizes.push(size);
            rows += size;
        });
        selectedSheet = rows ? selectedSheet : null;
        this.setState(
            { selectedSheet, sheetSizes },
            () => isSingle ? this.onButtonPress({}) : null
        );
    }

    render() {
        if (!this.state.checkDone) {
            return (
                <div className={style.infobox}>
                    Prüfe Datei ...
                </div>
            );
        } else if (!this.state.isExcel) {
            return (
                <div className={style.infobox} style={{ backgroundColor: '#fdd' }}>
                    Format ungültig!
                </div>
            );
        }
        const sheetNames = this.state.workbook ? this.state.workbook.SheetNames : this.props.data.sheetNames;
        return (
            <div>
                <div className={style.infobox} style={{ backgroundColor: '#dfd' }}>
                    <div>Excel-Datei erkannt</div>
                    <div>Anzahl Arbeitsblätt: { sheetNames.length }</div>
                </div>
                <div className={style.infobox}>
                    <div>Auswahl Arbeitsblätter:</div>
                    <div>
                        {sheetNames.map((sn: string, idx: number) =>
                            <div key={`sn_${sn}`}>
                                <input
                                    type='radio'
                                    checked={
                                        (this.state.selectedSheet && this.state.selectedSheet === sn)
                                        || (!this.state.selectedSheet && idx === 0 && +this.state.sheetSizes[idx] > 0)
                                    }
                                    value={sn}
                                    disabled={!this.state.sheetSizes[idx]}
                                    onChange={this.onSheetSelect}
                                />
                                {sn} <b>({this.state.sheetSizes[idx] || 0})</b>
                            </div>
                        )}
                        <div>
                            <input
                                type='button'
                                value='Weiter'
                                onClick={this.onButtonPress}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    onButtonPress(e: any) {
        const data = this.props.data;
        if (!data.sheetDataAll) {
            data.sheetNames = this.state.workbook.SheetNames;
            data.sheetDataAll = this.excel_tool.getJSONAll(this.state.workbook);
        }
        data.sheetName = this.state.selectedSheet;
        data.sheetSizes = this.state.sheetSizes;
        data.checkDaten = true;
        delete (data.raw);
        const sheetData = data.sheetDataAll[data.sheetName] || [];
        if (sheetData.length > 10000) {
           alert('Bitte verwenden Sie für die Erstellung einer Importschnittstelle eine Datei mit maximal 10000 Zeilen. ' +
                'Die verwendete Datei hat ' + sheetData.length + ' Zeilen!');
        } else if (sheetData.length) {
            this.props.onDataChange(data);
            this.props.onDone();
        }
    }

    onSheetSelect(e: any) {
        const selectedSheet = e.target.value;
        this.setState({ selectedSheet });
    }
}
